export default "__VITE_ASSET__55991fe9__"